/* Fulfilment Station - meetlaag voor sales en marketing.

   1. Houdt vast waar een bezoeker vandaan komt (utm-parameters en de klik-id's
      van Google, Meta, LinkedIn, Microsoft en TikTok).
   2. Stuurt die herkomst mee met een offerteaanvraag, zodat verkoop in HubSpot
      ziet uit welke campagne een lead komt.
   3. Laat beide formulieren eindigen op /pages/bedankt, zodat er een echte
      conversie-URL bestaat waar advertentieplatformen op kunnen meten.
   4. Meldt de conversie daar precies een keer.

   Opslaan gebeurt pas na toestemming. Zonder toestemming blijft de herkomst in
   het geheugen van deze ene paginaweergave en verdwijnt hij daarna. */
(function () {
  var KEY = 'fs-herkomst';
  var BEDANKT = '/pages/bedankt';
  var VLAG = 'fs-conversie';
  var VELDEN = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content',
                'gclid', 'gbraid', 'wbraid', 'fbclid', 'li_fat_id', 'msclkid', 'ttclid'];
  var KLIK = ['gclid', 'gbraid', 'wbraid', 'fbclid', 'li_fat_id', 'msclkid', 'ttclid'];

  function magOpslaan() {
    try { return localStorage.getItem('fs-cookie-consent') === 'granted'; } catch (e) { return false; }
  }
  function datum() { return new Date().toISOString().slice(0, 10); }
  function kort(s) { return String(s).replace(/[\r\n\t]/g, ' ').slice(0, 120); }

  /* --- 1. herkomst bepalen --------------------------------------------- */
  function uitHuidigeUrl() {
    var p, o = null;
    try { p = new URLSearchParams(location.search); } catch (e) { return null; }
    VELDEN.forEach(function (v) {
      var w = p.get(v);
      if (w) { o = o || {}; o[v] = kort(w); }
    });
    if (!o) return null;
    o.pagina = location.pathname;
    o.datum = datum();
    if (document.referrer && document.referrer.indexOf(location.host) < 0) {
      o.verwijzer = kort(document.referrer.split('?')[0]);
    }
    return o;
  }
  function uitVerwijzer() {
    if (!document.referrer || document.referrer.indexOf(location.host) > -1) return null;
    return { verwijzer: kort(document.referrer.split('?')[0]), pagina: location.pathname, datum: datum() };
  }

  var geheugen = null;
  function lees() {
    if (magOpslaan()) {
      try { var r = localStorage.getItem(KEY); if (r) return JSON.parse(r); } catch (e) {}
    }
    return geheugen;
  }
  function schrijf(o) {
    geheugen = o;
    if (magOpslaan()) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
  }
  function bijwerken() {
    var nieuw = uitHuidigeUrl() || uitVerwijzer();
    if (!nieuw) return;
    var b = lees() || {};
    if (!b.eerste) b.eerste = nieuw;
    b.laatste = nieuw;
    schrijf(b);
  }
  bijwerken();

  /* Gaat de bezoeker later alsnog akkoord, dan mag wat in het geheugen zit
     alsnog bewaard worden. De cookiebanner staat vooraan in de pagina, dus een
     klik daarop komt hier langs. */
  document.addEventListener('click', function () {
    if (geheugen && magOpslaan()) { try { localStorage.setItem(KEY, JSON.stringify(geheugen)); } catch (e) {} }
  }, true);

  function regel(x, label) {
    if (!x) return '';
    var s = [];
    if (x.utm_source) s.push('bron ' + x.utm_source);
    if (x.utm_medium) s.push('kanaal ' + x.utm_medium);
    if (x.utm_campaign) s.push('campagne ' + x.utm_campaign);
    if (x.utm_term) s.push('zoekterm ' + x.utm_term);
    if (x.utm_content) s.push('variant ' + x.utm_content);
    KLIK.forEach(function (k) { if (x[k]) s.push(k + ' ' + x[k]); });
    if (!s.length && x.verwijzer) s.push('via ' + x.verwijzer);
    if (!s.length) return '';
    return label + ': ' + s.join(', ') + ' | binnengekomen op ' + x.pagina + ' op ' + x.datum;
  }
  function samenvatting() {
    var b = lees();
    if (!b) return '';
    /* Kwam iemand maar een keer binnen, dan is een regel genoeg. Pas als het
       eerste en het laatste bezoek verschillen wordt het twee regels. */
    var zelfde = JSON.stringify(b.eerste || null) === JSON.stringify(b.laatste || null);
    if (zelfde) return regel(b.laatste || b.eerste, 'Herkomst');
    var e = regel(b.eerste, 'Eerste bezoek'), l = regel(b.laatste, 'Laatste bezoek');
    if (e && l) return e + '\n' + l;
    return e || l;
  }
  window.fsHerkomst = function () { return { ruw: lees(), tekst: samenvatting() }; };

  /* --- 2. herkomst meesturen met de inzending --------------------------- */
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (u, o) {
      var uu = u, oo = o;
      try {
        var url = (typeof u === 'string') ? u : (u && u.url) || '';
        if (url.indexOf('hsforms.com/submissions') > -1 && o && typeof o.body === 'string') {
          var tekst = samenvatting();
          if (tekst) {
            var d = JSON.parse(o.body);
            if (d && d.fields && d.fields.length) {
              var m = null, i;
              for (i = 0; i < d.fields.length; i++) { if (d.fields[i].name === 'message') { m = d.fields[i]; break; } }
              if (m) { m.value = (m.value ? m.value + '\n\n' : '') + tekst; }
              else { d.fields.push({ name: 'message', value: tekst }); }
              oo = {};
              for (i in o) { if (Object.prototype.hasOwnProperty.call(o, i)) oo[i] = o[i]; }
              oo.body = JSON.stringify(d);
            }
          }
        }
      } catch (e) { uu = u; oo = o; }
      return origFetch.call(this, uu, oo);
    };
  }

  /* --- 3. na een inzending naar de bedanktpagina ------------------------ */
  function naarBedankt(bron) {
    try { sessionStorage.setItem(VLAG, bron); } catch (e) {}
    location.href = BEDANKT;
  }

  /* Het eigen formulier vervangt bij succes zijn inhoud door een blok dat
     begint met een kop "Bedankt". Een foutmelding doet dat niet. */
  var eigen = document.querySelector('[data-quote-form]');
  if (eigen && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      var k = eigen.querySelector('h3');
      if (k && /^Bedankt/i.test(k.textContent.trim())) { mo.disconnect(); naarBedankt('offerteformulier'); }
    });
    mo.observe(eigen, { childList: true, subtree: true });
  }

  /* De HubSpot-insluiting staat op een ander domein en meldt zich via een
     bericht aan het venster. */
  window.addEventListener('message', function (ev) {
    try {
      var d = ev.data;
      if (d && d.type === 'hsFormCallback' && d.eventName === 'onFormSubmitted') naarBedankt('hubspot-formulier');
    } catch (e) {}
  });

  /* --- 4. de conversie melden ------------------------------------------ */
  if (location.pathname.indexOf(BEDANKT) === 0) {
    var bron = null;
    try { bron = sessionStorage.getItem(VLAG); sessionStorage.removeItem(VLAG); } catch (e) {}
    /* Zonder vlag is dit geen verse inzending maar iemand die de pagina
       rechtstreeks opent. Dan tellen we niets, anders lopen de cijfers op. */
    if (bron) {
      var b = lees() || {}, h = b.laatste || b.eerste || {};
      var gegevens = {
        formulier: bron,
        bron: h.utm_source || (h.verwijzer ? 'verwijzing' : 'direct'),
        kanaal: h.utm_medium || '',
        campagne: h.utm_campaign || ''
      };
      window.dataLayer = window.dataLayer || [];
      var d2 = { event: 'lead_aanvraag' };
      for (var k in gegevens) { if (Object.prototype.hasOwnProperty.call(gegevens, k)) d2[k] = gegevens[k]; }
      window.dataLayer.push(d2);

      /* Het eigen formulier meldt generate_lead al zelf op de pagina waar het
         staat. Alleen de HubSpot-insluiting deed dat nog niet, dus die melden
         we hier. Zo blijft het een gebeurtenis per aanvraag. */
      if (bron === 'hubspot-formulier') {
        try { if (typeof window.gtag === 'function') window.gtag('event', 'generate_lead', gegevens); } catch (e) {}
      }

      /* Ruimte voor de conversietags van de advertentieplatformen. Vul het
         nummer in en haal het commentaarteken weg zodra het account er is.

         Google Ads:  window.gtag && gtag('event','conversion',{send_to:'AW-000000000/xxxxxxxxxxx'});
         Meta:        window.fbq && fbq('track','Lead');
         LinkedIn:    window.lintrk && lintrk('track',{conversion_id:0000000});
         Microsoft:   window.uetq && uetq.push('event','lead',{}); */
    }
  }
})();


/* ==================================================================
   Deel 2: kwalificatie en conversiesplitsing.
   Toegevoegd in thema 2.3. Staat bewust in dit bestand en niet in een
   los bestand, zodat layout/theme.liquid niet aangeraakt hoefde te worden.
   Eigen functieblok, eigen opslagsleutels, raakt het bovenstaande niet.
   ================================================================== */

/* Fulfilment Station - kwalificatie en conversiesplitsing.

   Dit bestand draait NAAST assets/fs-marketing.js en wijzigt daar niets aan.
   Het houdt zijn eigen sleutels aan, zodat de bestaande meting blijft werken
   zoals hij werkt.

   Wat het doet:
   1. Vangt bij elke inzending de gekozen orderklasse en het e-mailadres.
   2. Hasht dat adres meteen met SHA-256, zodat er nooit een leesbaar adres
      in de opslag van de browser staat.
   3. Meldt op /pages/bedankt de conversie, met een waarde per orderklasse.
   4. Geeft de klasse mee aan de dataLayer, zodat je er in GA4 en in Tag
      Manager op kunt segmenteren.

   Welke klasse als gekwalificeerd telt, bepalen we pas na een evaluatie
   (besluit 23-10-2026). Tot die tijd geeft het script alleen de klasse door. */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     INSTELLEN. Het label van de conversieactie.
     Je vindt het label in Google Ads onder Doelen, Conversies, de actie
     openen, Tagsetup, Tag zelf installeren. Het ziet eruit als
     'AW-123456789/AbCdEfGhIjKlMnOp'.
     ------------------------------------------------------------------ */
  var CONVERSIE   = 'AW-11094696549/gu5DCN_n6qYdEOXErqop';   /* Aanvraag offerte - website: elke aanvraag telt (besluit 23-10-2026) */

  var VELD        = 'orders_per_maand';   /* name-attribuut van de keuzelijst */
  var BEDANKT     = '/pages/bedankt';
  var S_ORDERS    = 'fs-kw-orders';
  var S_HASH      = 'fs-kw-hash';
  var S_VLAG      = 'fs-kw-vlag';
  var S_GUID      = 'fs-kw-guids';
  var S_TIJD      = 'fs-kw-tijd';

  var LABELS = {
    '0':     'tot 300',
    '300':   '300 – 1.500',
    '1500':  '1.500 – 3.000',
    '3000':  '3.000 – 7.500',
    '7500':  '7.500 – 15.000',
    '15000': '15.000 – 30.000',
    '30000': 'meer dan 30.000'
  };

  /* Waarde per aanvraag voor Google Ads: orders per dag (midden van de klasse,
     de hoogste klasse op de ondergrens) keer 365 dagen keer 0,50 euro marge
     per order, gedeeld door 20 omdat 1 op de 20 aanvragen klant wordt
     (besluit 23-10-2026). Onbekend telt als de laagste klasse. */
  var WAARDE = {
    '0':     46,
    '300':   274,
    '1500':  684,
    '3000':  1597,
    '7500':  3422,
    '15000': 6844,
    '30000': 9125
  };
  var WAARDE_ONBEKEND = 46;

  function zet(sleutel, waarde) {
    try { sessionStorage.setItem(sleutel, waarde); } catch (e) {}
  }
  function pak(sleutel) {
    try {
      var v = sessionStorage.getItem(sleutel);
      sessionStorage.removeItem(sleutel);
      return v || '';
    } catch (e) { return ''; }
  }

  /* --- 1. e-mailadres normaliseren en hashen -------------------------- */

  /* Google vergelijkt op een genormaliseerd adres. Slaan we die stap over,
     dan matcht een deel van de adressen niet en lijkt verbeterde conversies
     slechter te werken dan hij doet. */
  function normaliseer(adres) {
    var s = String(adres || '').trim().toLowerCase();
    var apenstaart = s.indexOf('@');
    if (apenstaart < 1 || apenstaart === s.length - 1) return '';
    var lokaal = s.slice(0, apenstaart);
    var domein = s.slice(apenstaart + 1);
    /* Gmail negeert punten in het lokale deel en alles achter een plus. */
    if (domein === 'gmail.com' || domein === 'googlemail.com') {
      lokaal = lokaal.split('+')[0].replace(/\./g, '');
      domein = 'gmail.com';
    }
    return lokaal + '@' + domein;
  }

  function hash(adres, klaar) {
    var m = normaliseer(adres);
    if (!m || !window.crypto || !window.crypto.subtle || !window.TextEncoder) {
      klaar(''); return;
    }
    try {
      window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(m)).then(
        function (buffer) {
          var bytes = new Uint8Array(buffer), hex = '';
          for (var i = 0; i < bytes.length; i++) {
            hex += ('0' + bytes[i].toString(16)).slice(-2);
          }
          klaar(hex);
        },
        function () { klaar(''); }
      );
    } catch (e) { klaar(''); }
  }

  /* --- 2. opvangen bij de inzending ----------------------------------- */

  /* We luisteren in de vangfase, zodat we erbij zijn voordat het formulier
     zichzelf opruimt of de pagina doorstuurt. Twee keer opslaan is niet erg,
     de laatste waarde wint. */
  function onthoud(formulier) {
    if (!formulier || !formulier.querySelector) return;
    var keuze = formulier.querySelector('[name="' + VELD + '"]');
    var mail  = formulier.querySelector('[name="email"]') ||
                formulier.querySelector('input[type="email"]');

    zet(S_VLAG, '1');
    zet(S_TIJD, String(Date.now()));
    zet(S_ORDERS, keuze && keuze.value !== '' ? String(keuze.value) : '');

    if (mail && mail.value) {
      hash(mail.value, function (hex) { if (hex) zet(S_HASH, hex); });
    }
  }

  document.addEventListener('submit', function (ev) {
    onthoud(ev.target);
  }, true);

  /* Formulieren die met een knop versturen in plaats van met een echte
     submit komen hier binnen. */
  document.addEventListener('click', function (ev) {
    var el = ev.target;
    while (el && el !== document) {
      if (el.tagName === 'BUTTON' || (el.tagName === 'INPUT' && el.type === 'submit')) {
        if (el.type !== 'button' && el.form) onthoud(el.form);
        else {
          var f = el.closest ? el.closest('form') : null;
          if (f) onthoud(f);
        }
        return;
      }
      el = el.parentNode;
    }
  }, true);

  /* Voor formulieren die hun aanvraag zelf afhandelen en de vlaggen hierboven
     wissen, zoals het eigen contactformulier: meld de conversie direct, met
     dezelfde waarde per klasse. Zo staat de waardetabel op een plek. */
  window.fsMeldConversie = function (orders) {
    var getal  = parseInt(orders, 10);
    var bekend = !isNaN(getal) && LABELS.hasOwnProperty(String(getal));
    var mailhash = pak(S_HASH);
    if (!CONVERSIE || typeof window.gtag !== 'function') return;
    try {
      if (mailhash) {
        window.gtag('set', 'user_data', { sha256_email_address: mailhash });
      }
      window.gtag('event', 'conversion', {
        send_to: CONVERSIE,
        value: bekend ? WAARDE[String(getal)] : WAARDE_ONBEKEND,
        currency: 'EUR'
      });
    } catch (e) {}
  };

  /* --- 3. melden op de bedanktpagina ---------------------------------- */

  if (location.pathname.indexOf(BEDANKT) !== 0) return;

  var vlag = pak(S_VLAG);

  /* Een vlag die blijft staan omdat iemand wel op versturen klikte maar nooit
     op de bedanktpagina aankwam, mag later geen spookconversie opleveren. Na
     een kwartier vervalt hij. Gemeten op 22 oktober 2026: het eigen formulier
     op de contactpagina stuurt niet door, dus zonder deze grens bleef die vlag
     de rest van de sessie klaarliggen. */
  var tijd = parseInt(pak(S_TIJD), 10);
  if (vlag && (isNaN(tijd) || Date.now() - tijd > 15 * 60 * 1000)) vlag = '';

  /* Het ingesloten HubSpot-formulier staat op een ander domein en stuurt
     geen bericht naar deze pagina. Gemeten op 22 oktober 2026: nul berichten
     bij een inzending. HubSpot stuurt wel zelf door naar deze pagina en zet
     daarbij ?submissionGuid= in de URL. Dat is dus ons bewijs dat er echt
     is ingezonden, en het is niet na te maken door de pagina gewoon te
     openen. */
  var guid = '';
  try { guid = new URLSearchParams(location.search).get('submissionGuid') || ''; } catch (e) {}

  /* Vernieuwt iemand de bedanktpagina, dan staat die parameter er nog steeds.
     Daarom onthouden we welke inzending we al geteld hebben. */
  var alGeteld = false;
  if (guid) {
    try {
      var eerder = sessionStorage.getItem(S_GUID) || '';
      alGeteld = eerder.indexOf('|' + guid + '|') > -1;
      if (!alGeteld) sessionStorage.setItem(S_GUID, (eerder + '|' + guid + '|').slice(-800));
    } catch (e) {}
  }

  var viaHubspot = !!guid && !alGeteld;

  /* Geen vlag en geen verse inzending van HubSpot betekent dat iemand deze
     pagina gewoon opent. Dan tellen we niets, anders lopen de cijfers op. */
  if (!vlag && !viaHubspot) return;

  var ruw      = pak(S_ORDERS);
  var mailhash = pak(S_HASH);
  var getal    = parseInt(ruw, 10);
  var bekend   = !isNaN(getal) && LABELS.hasOwnProperty(String(getal));

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'lead_kwalificatie',
    formulier: vlag ? 'eigen-formulier' : 'hubspot-insluiting',
    orders_per_maand: bekend ? String(getal) : 'onbekend',
    orders_label: bekend ? LABELS[String(getal)] : 'onbekend',
    email_sha256: mailhash
  });

  /* fs-marketing.js meldt lead_aanvraag alleen als zijn eigen vlag staat, en
     die staat nooit bij een inzending via de insluiting. Dan vullen wij dat
     gat, maar alleen als het er nog niet staat, zodat er niets dubbel telt. */
  var alGemeld = window.dataLayer.some(function (e) {
    return e && e.event === 'lead_aanvraag';
  });
  if (!alGemeld) {
    window.dataLayer.push({
      event: 'lead_aanvraag',
      formulier: vlag ? 'eigen-formulier' : 'hubspot-insluiting'
    });

    /* Deel 1 meldt generate_lead alleen op de route die nooit afgaat, en het
       eigen contactformulier meldt het sinds 2.4 zelf. Deze route deed het nog
       niet, waardoor generate_lead niet alle aanvragen dekte. */
    if (typeof window.gtag === 'function') {
      try {
        window.gtag('event', 'generate_lead', {
          form_naam: vlag ? 'eigen-formulier' : 'hubspot-insluiting',
          pagina: location.pathname
        });
      } catch (e) {}
    }
  }

  /* Rechtstreeks via gtag. Draai je dit liever via Tag Manager, laat het
     label hierboven leeg en bouw de tags op de gebeurtenis lead_kwalificatie.
     Allebei doen betekent dubbel tellen. */
  if (CONVERSIE && typeof window.gtag === 'function') {
    try {
      if (mailhash) {
        window.gtag('set', 'user_data', { sha256_email_address: mailhash });
      }
      window.gtag('event', 'conversion', {
        send_to: CONVERSIE,
        value: bekend ? WAARDE[String(getal)] : WAARDE_ONBEKEND,
        currency: 'EUR'
      });
    } catch (e) {}
  }

  /* De klasse ook aan GA4 meegeven, zodat je elk rapport kunt splitsen.
     Leg orders_per_maand in GA4 vast als aangepaste dimensie op gebeurtenis-
     niveau, anders zie je de parameter wel binnenkomen maar niet terug. */
  if (typeof window.gtag === 'function') {
    try {
      window.gtag('event', 'lead_kwalificatie', {
        orders_per_maand: bekend ? String(getal) : 'onbekend'
      });
    } catch (e) {}
  }
})();
